<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<circle cx="6" cy="2" r="1.5" />
	<circle cx="6" cy="6" r="1.5" />
	<circle cx="6" cy="10" r="1.5" />
</svg>
</template>